import {isUndefined} from 'lodash'

export abstract class FormatHelper {
  static numberToCurrency(numberToConvert: number | null | undefined) {
    if (numberToConvert === null || isUndefined(numberToConvert)) return ''
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numberToConvert)
  }
}
